import { Island } from '../../islands/island.class';

export type FormatValidationParams = {
	letter: string;
	islandDescription: string;
	location?: string;
	issue: string;
};

// A/B/C letter for the island in the shared connection-chain order (islands.orderedChildren) —
// the same order the blueprint labels use — so a validation can be tied to an island beyond its
// size. Empty for single-island kitchens.
export const getIslandLetter = (island: Island): string => {
	const ordered = island.refMap?.islands?.orderedChildren ?? [];
	if (ordered.length <= 1) return '';
	const index = ordered.findIndex((candidate) => candidate.id === island.id);
	return index < 0 ? '' : String.fromCharCode(65 + index);
};

// Key-value validation text so the location and the problem parse apart cleanly. Uses " · " as the
// field separator so it never collides with the " | " already inside island.description.
export const formatValidation = (params: FormatValidationParams): string => {
	const { letter, islandDescription, location, issue } = params;
	const label = letter ? `Island ${letter} (${islandDescription})` : (islandDescription || 'Island');
	const where = location ? `${label} · ${location}` : label;
	return `Location: ${where} · Issue: ${issue}`;
};
